import { Link } from "react-router-dom";
import image from "../images/present4.jpg";
import tree from "../images/tree.png";
import React from "react";
import Countdown from "./Countdown";
import GetStarted from "./core/GetStarted";
import "../styles/pages/home.scss";
import "../styles/pages/home.scss";

const Home = () => {
  return (
    <div>
      <h1>North Pole Post</h1>
      <Countdown />
      <div className="row p-0 m-0">
        <div className="col p-0 m-0">
          <div className="row row-cols-2 p-0 m-0">
            <Link to="/activity-hangman" className="activity">
              <div className="col">
                <div className="d-flex flex-column">
                  <h5 className="center-fix">Hangman</h5>
                  <img className="present" src={image} alt="present" />
                </div>
              </div>
            </Link>
            <div className="col"></div>
            <div className="col"></div>
            <Link to="/activity-minesweeper" className="activity">
              <div className="col">
                <div className="d-flex flex-column">
                  <h5 className="center-fix">Minesweeper</h5>
                  <img className="present" src={image} alt="present" />
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="col p-0 m-0">
          <img className="tree" alt="Christmas Tree" src={tree} />
        </div>
        <div className="col p-0 m-0">
          <div className="row row-cols-2 p-0 m-0">
            <div className="col"></div>
            <Link to="/activity-memory" className="activity">
              <div className="col">
                <div className="d-flex flex-column">
                  <h5 className="center-fix">Memory Game</h5>
                  <img className="present" src={image} alt="present" />
                </div>
              </div>
            </Link>
            <Link to="/activity-tic-tac-toe" className="activity">
              <div className="col">
                <div className="d-flex flex-column">
                  <h5 className="center-fix">Tic Tac Toe</h5>
                  <img className="present" src={image} alt="present" />
                </div>
              </div>
            </Link>
          </div>
        </div>
        <GetStarted />
      </div>
    </div>
  );
};
export default Home;
